module.exports = __webpack_public_path__ + "media/applicants/device_signup_4-a6c92e95.jpg";